import React, { useEffect } from 'react'
import PageLoader from 'shared/components/PageLoader'
import { useAuth } from './shared/hooks/useAuth'

const Logout: React.FC = () => {
  const authContext = useAuth()

  useEffect(() => {
    authContext.signOut()
  })

  return <PageLoader />
}

export default Logout
